import { lazy } from "react";

export { TASKS_ADMIN_PATH } from "./path";
export const TasksAdmin = lazy(() => import("./page"));
